import { Button } from "@/components/ui/button";
import { RefinedDataItem, ValidationError } from "@/lib/useQuery/useGetExportData";
import { ChevronLeft, Pencil } from "lucide-react";
import { useState } from "react";
import NoMatchError from "./airtable/NoMatchError";

export type ErrorComponentProps<T = undefined> = { field: RefinedDataItem[string], error: T extends undefined ? ValidationError : ValidationError }

export default function TableCellError({ field }: { field: RefinedDataItem[string] }) {
    let ErrorComponent: React.FC<ErrorComponentProps> | null = null;
    const [error, setError] = useState<ValidationError | null>(null);
    console.log(error)
    if (error?.code === 'no_match')
        ErrorComponent = NoMatchError;
    if(error?.code === 'missing_data')
        ErrorComponent = NoMatchError;
    if(error?.code === 'invalid_type')
        ErrorComponent = NoMatchError;
    return (
        <>
            {error
                ? (
                    <div className="flex flex-col gap-2">
                        <Button
                            variant='ghost'
                            className='flex items-center gap-2 p-0 pr-3 w-min h-min'
                            onClick={() => setError(null)}
                        >
                            <ChevronLeft size={18} /> <span className="mb-1">Back</span>
                        </Button>
                        {!!ErrorComponent && <ErrorComponent error={error} field={field} />}
                    </div>
                )
                : (
                    <>
                        {field?.errors?.map((error) => (
                            <div className="flex items-center justify-between" key={error.code}>
                                <p className="">{error.message}</p>
                                <Button
                                    size='action'
                                    onClick={() => setError(error)}
                                    className="cursor-pointer"
                                >
                                    <Pencil size={16} />
                                </Button>
                            </div>
                        ))}
                    </>
                )}
        </>
    )
}